$(document).on("turbo:load ready", function() {
  new SmoothAnchorSchroll().addHashClickHandler();
});

// Exposed on window for cross-bundle access (esbuild IIFE scoping)
var SmoothAnchorSchroll = window.SmoothAnchorSchroll = function() {
  var obj = this;
  var headerHeight = $('#site-header').height();

  obj.addHashClickHandler = function() {
    // Use namespaced events to prevent duplicate handlers on turbo:load + ready
    $('a[href*="#"]:not([href="#"])').off("click.smoothscroll").on("click.smoothscroll", function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          obj.scrollTo(target);
          return false;
        }
      }
    });
  };

  obj.scrollTo = function(target, callback) {
    $('html, body').animate({
      scrollTop: (target.offset().top - headerHeight)
    }, 600, function() {
      if (callback && typeof(callback) === "function") {
        callback();
      }
    });
  };
};
